import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
import { MoodboardItem } from '../types/moodboard';
interface MoodboardCardProps {
  item: MoodboardItem;
  onDelete: (id: string) => void;
  isHighlighted?: boolean;
}
export function MoodboardCard({
  item,
  onDelete,
  isHighlighted = true
}: MoodboardCardProps) {
  const renderContent = () => {
    switch (item.type) {
      case 'image':
        return <div className="relative w-full overflow-hidden" data-id="element-159">
            <img src={item.content} alt={item.title || 'Moodboard image'} className="w-full h-auto object-cover transition-opacity duration-500 hover:opacity-90" loading="lazy" data-id="element-160" />
          </div>;
      case 'note':
        return <div className="px-4 sm:px-6 py-8 sm:py-10 min-h-[120px] sm:min-h-[140px] flex flex-col justify-center border-b border-border" data-id="element-161">
            <p className="text-[13px] font-sans font-normal leading-[1.8] text-[#1A1A1A]" data-id="element-162">
              "{item.content}"
            </p>
          </div>;
      case 'link':
        return <div className="px-4 sm:px-6 py-6 sm:py-8 border-b border-border" data-id="element-163">
            <p className="font-heading font-normal text-[11px] tracking-[0.2em] uppercase text-[#666] mb-3" data-id="element-164">
              {item.title || 'REFERENCE'}
            </p>
            {item.description && <p className="text-[12px] text-[#444] leading-[1.7] font-sans mb-4" data-id="element-165">
                {item.description}
              </p>}
            <a href={item.content} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-heading text-[11px] tracking-[0.15em] uppercase text-black border-b border-black pb-0.5 hover:opacity-60 transition-opacity" data-id="element-166">
              VISITA
              <ExternalLink className="w-3 h-3" data-id="element-167" />
            </a>
          </div>;
      case 'color_palette':
        const colors = item.content.split(',').map(c => c.trim()).filter(c => c.startsWith('#'));
        return <div className="p-4 sm:p-6" data-id="element-168">
            <p className="font-heading font-normal text-[10px] tracking-[0.25em] uppercase text-[#666] mb-4" data-id="element-169">
              PALETTE
            </p>
            <div className="flex w-full h-20 overflow-hidden" data-id="element-170">
              {colors.map((color, idx) => <div key={idx} className="flex-1 h-full transition-all duration-300 hover:flex-[1.5]" style={{
              backgroundColor: color
            }} title={color} data-id="element-171" />)}
            </div>
          </div>;
      default:
        return null;
    }
  };
  return <motion.div layout initial={{
    opacity: 0,
    y: 15
  }} animate={{
    opacity: isHighlighted ? 1 : 0.2,
    y: 0
  }} exit={{
    opacity: 0,
    transition: {
      duration: 0.2
    }
  }} transition={{
    duration: 0.5,
    ease: [0.22, 1, 0.36, 1]
  }} className={`break-inside-avoid mb-4 sm:mb-8 group transition-opacity duration-500`} data-id="element-172">
      <div className="overflow-hidden border border-border bg-white relative hover:border-[#999] transition-colors duration-300" data-id="element-173">
        {/* Hover Delete */}
        <div className="absolute top-2 sm:top-3 right-2 sm:right-3 z-10 opacity-100 sm:opacity-0 group-hover:opacity-100 transition-opacity duration-200" data-id="element-174">
          <button className="font-heading text-[9px] tracking-[0.15em] uppercase text-[#666] hover:text-black bg-white/90 backdrop-blur-sm px-3 py-1.5 border border-border transition-colors" onClick={() => onDelete(item.id)} data-id="element-175">
            RIMUOVI
          </button>
        </div>

        {renderContent()}

        <div className="px-4 sm:px-6 py-4 sm:py-5" data-id="element-176">
          {item.type !== 'note' && item.type !== 'link' && item.title && <h3 className="font-heading font-normal text-[11px] tracking-[0.2em] uppercase mb-2 text-black" data-id="element-177">
              {item.title}
            </h3>}
          {item.description && <p className="text-[12px] text-[#666] mb-4 line-clamp-3 leading-[1.6] font-sans" data-id="element-178">
              {item.description}
            </p>}

          {item.tags.length > 0 && <div className="flex flex-wrap gap-2 mt-3" data-id="element-179">
              {item.tags.map((tag, idx) => <span key={idx} className="font-heading text-[9px] tracking-[0.15em] uppercase text-[#666] border border-border px-2 py-1 hover:text-black hover:border-[#999] transition-colors" data-id="element-180">
                  {tag}
                </span>)}
            </div>}
        </div>
      </div>
    </motion.div>;
}